export default "__VITE_ASSET__DrdV7H2J__"